// Hooks for the mock API's Test tools (test users, sign in as, the clock, reset). With the real backend
// `api.demo` is missing: useIsDemo() is false and the Test tools button is not there.
import { useQuery } from '@tanstack/react-query'
import { useApi } from '@/api/ApiProvider'
import { useChange } from '@/api/useChange'

const keys = { testUsers: ['test', 'users'] as const }

export function useIsDemo(): boolean {
  return !!useApi().demo
}

/** the test users with their password and the current 2-step code (a new code every 30 s, so asked again) */
export function useTestUsers(enabled: boolean) {
  const api = useApi()
  return useQuery({
    queryKey: keys.testUsers,
    queryFn: () => api.demo!.listTestUsers(),
    enabled: enabled && !!api.demo,
    refetchInterval: 5_000,
  })
}

export const useSignInAs = () => useChange((api, userId: string) => api.demo!.signInAs(userId))
export const useAdvanceClock = () => useChange((api, hours: number) => api.demo!.advanceClock(hours))
export const useNextDayTen = () => useChange((api, _input: undefined) => api.demo!.advanceToNextDayTen())
export const useResetDemo = () => useChange((api, _input: undefined) => api.demo!.resetDemo())
